// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__V7kMc","load_nav":"Nav_load_nav__DOhJQ","menu_container":"Nav_menu_container__Aoqdd","active":"Nav_active__PROZR","menu_button":"Nav_menu_button__SXd4d"};